<template>
  <nav class="navbar">
    <div class="secondBox max-w-1400">
      <div class="logo">
        <!-- <img
          :src="require('@/page/dealcorpefectivo2/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">FACICASA S.A. DE C.V., SOFOM, E.N.R.</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Página Delantera</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/questions' }" class="Li2">
          <router-link to="/questions" class="nav-link2">
            <span class="routeText2">Términos y Problemas</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/service' }" class="Li3">
          <router-link to="/service" class="nav-link3">
            <span class="routeText3">Acerca de la aplicación</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li4">
          <!-- <router-link to="/protocol" class="nav-link4">
            <span class="routeText4">Acuerdo de privacidad</span>
          </router-link> -->
          <a href="https://fsmiw.fssskcafitasr.com/help/privacy_agreement" class="nav-link3" target="_blank">
            <span class="routeText4">Acuerdo de privacidad</span>
          </a>
        </li>
        <!-- <li
          :class="{ 'active-link': $route.path === '/protocol' }"
          class="lastLi"
        >
          <router-link to="/protocol" class="nav-link5">
            <span class="routeText5">Acuerdo de Privacidad</span>
          </router-link>
        </li> -->
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 130px;
  padding: 0 30px;
  background-color: #FFFFFF;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
}

.title {
  width: 480px;
  height: 24px;
  font-size: 20px;
  font-family: SF Pro-Black Italic;
  font-weight: 600;
  color: #4F4F4F;
  line-height: 23px;
  padding-left: 17px;
  /* text-transform: uppercase; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 18px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #4F4F4F ;
  line-height: 29px;
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
  text-align: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  padding: 8px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  padding-left: 4px;
  padding-right: 4px;
}
.Li1 {
  width: 200px;
}
.Li2 {
  width: 220px;
}
.Li3 {
  width: 220px;
}
.Li4 {
  width: 230px;
}
/* .Li5 {
  width: 250px;
} */
/* 这个如果给margin-right底部可能会出现边距的问题 */
/* .Li4 {
  width: 250px;
  
} */

.active-link {
  /* background: linear-gradient(45deg, #F59120, #F95C40); */
  background-color: #32BFC1;
  /* border-color: #dae633; */
  border-radius: 20px;
}



.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;

  color: #FFFFFF;
}
</style>